// namespace (소문자)
export const NAMESPACE = 'message';
//getters
// export const REVIEW = 'REVIEW';
// export const REVIEWS = 'REVIEWS';
// export const REPORTS = 'REPORTS';
// export const REVIEW_COUNT = 'REVIEW_COUNT';
// //actions
export const FETCH_MESSAGE_BROWSER_TOKENS = 'FETCH_MESSAGE_BROWSER_TOKENS';
export const UPDATE_MESSAGE_BROWSER_TOKENS = 'UPDATE_MESSAGE_BROWSER_TOKENS';

// export const CREATE_REVIEW = 'CREATE_REVIEW';
// export const DELETE_REVIEW = 'DELETE_REVIEW';
// export const FETCH_REVIEW = 'FETCH_REVIEW';
// export const FETCH_REVIEWS = 'FETCH_REVIEWS';
// export const FETCH_REVIEW_REPORTS = 'FETCH_REVIEW_REPORTS';
// export const FETCH_ALL_REVIEW_REPORTS = 'FETCH_ALL_REVIEW_REPORTS';
// export const REPORT_REVIEW = 'REPORT_REVIEW';
// export const REPORT_REVIEW_USER = 'REPORT_REVIEW_USER';
// export const UPDATE_REVIEW_VISIBLE = 'UPDATE_REVIEW_VISIBLE';
// export const UPDATE_REVIEW_REPORT_VISIBLE = 'UPDATE_REVIEW_REPORT_VISIBLE';
// export const FETCH_REVIEW_CHECK = 'FETCH_REVIEW_CHECK';
// export const FETCH_REVIEW_SCORE = 'FETCH_REVIEW_SCORE';
// export const UPDATE_REVIEW_CHOICE_COUNT = 'UPDATE_REVIEW_CHOICE_COUNT';
// export const FETCH_REVIEW_POPUP = 'FETCH_REVIEW_POPUP';
// export const UPDATE_REVIEW_POPUP = 'UPDATE_REVIEW_POPUP';

// //mutations
// export const SET_REVIEW = 'SET_REVIEW';
// export const SET_REVIEWS = 'SET_REVIEWS';
// export const SET_REPORTS = 'SET_REPORTS';
